import React from 'react';
import { Truck, MapPin, Clock, Shield } from 'lucide-react';

const CultivarLog = () => {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section
        className="relative h-[500px] flex items-center justify-center text-white"
        style={{
          backgroundImage: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/ljih5j0x_Editedimage_1779910674881.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_primeiras-paginas/artifacts/gc3odst1_Sem%20t%C3%ADtulo-1log.png" 
              alt="Cultivar Log" 
              className="h-32 mx-auto drop-shadow-2xl"
            />
          </div>
          <p className="text-3xl font-semibold mb-4">TRANSPORTADORA</p>
          <p className="text-xl max-w-3xl mx-auto">
            Na cultivar Log somos especialistas em transporte de insumos e produtos agrícolas, conectando o produtor às melhores soluções logísticas.
          </p>
        </div>
      </section>

      {/* Description */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-800 mb-6">Nossa Frota</h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                Com equipe experiente, frota moderna e foco em resultados, garantimos entregas seguras, pontuais e com o cuidado que o agronegócio exige.
              </p>
              <div className="bg-blue-50 rounded-xl p-6 mb-6">
                <h3 className="text-2xl font-bold text-blue-600 mb-4">Cultivando produtividade, colhendo confiança.</h3>
              </div>
            </div>
            <div
              className="h-96 rounded-xl shadow-2xl bg-cover bg-center"
              style={{
                backgroundImage: 'url(https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/imh4blvj_WhatsApp%20Image%202026-05-27%20at%2011.38.32.jpeg)',
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">Nossos Diferenciais</h2>
          <div className="grid md:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-2xl transition-shadow">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Truck className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Frota Moderna</h3>
              <p className="text-gray-600 text-sm">Equipamentos preparados para o agronegócio</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-2xl transition-shadow">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Cobertura Nacional</h3>
              <p className="text-gray-600 text-sm">Atendemos em todo o Brasil</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-2xl transition-shadow">
              <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Pontualidade</h3>
              <p className="text-gray-600 text-sm">Entregas no prazo estabelecido</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-2xl transition-shadow">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Segurança</h3>
              <p className="text-gray-600 text-sm">Produtos protegidos do início ao fim</p>
            </div>
          </div>
        </div>
      </section>

      {/* Galeria de Frota */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center text-gray-800 mb-12">Nossa Frota em Ação</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/203x4fqn_WhatsApp%20Image%202026-05-27%20at%2011.37.39.jpeg"
                alt="Caminhão Cultivar Log carregando produtos"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/imh4blvj_WhatsApp%20Image%202026-05-27%20at%2011.38.32.jpeg"
                alt="Frota Cultivar Log ao pôr do sol"
                className="w-full h-64 object-cover"
              />
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow">
              <img
                src="https://customer-assets.emergentagent.com/job_f1f17df6-0a32-4d0a-b237-628c328d9963/artifacts/19p56pit_WhatsApp%20Image%202026-05-27%20at%2011.30.04.jpeg"
                alt="Frota de caminhões Cultivar Log"
                className="w-full h-64 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-blue-600 text-white text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Precisa de transporte para sua safra?</h2>
          <p className="text-xl mb-8">Entre em contato e conheça nossas soluções logísticas</p>
          <a
            href="/contato"
            className="inline-block bg-white text-blue-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            SOLICITAR ORÇAMENTO
          </a>
        </div>
      </section>
    </div>
  );
};

export default CultivarLog;